    angular.module('document')
        .factory('DocumentType', function ($resource) {
            return $resource('/crm/api/document-type/:id', {doc: '@doc'}, {
                list: {method: 'GET', isArray: true},
                get: {method: 'GET'},
                table: {method: 'GET', isArray: false, url: '/crm/api/document-type/table'},
                update: {method: 'PUT'},
                remove: {method: 'DELETE'}
            });
        })
        .service('DocumentTypeService', function ($rootScope, modals, DocumentType) {
            this.edit = id => DocumentType.get({id: id}, entity => this.editModal(entity));
            this.editModal = entity => modals.open('app/document-type/edit-modal.html', 'DocumentTypeDialogController', entity, {size: 'md'}, "$ctrl");
            this.addModal = () => {
                let entity = {
                    id: null,
                    active: true
                };
                return this.editModal(entity);
            };
            this.remove = item => {
                return modals.confirmDelete(item.name, () => DocumentType.delete({id: item.id}, () => $rootScope.$broadcast('document-type.updated')).$promise);
            };
        })
        .component('documentTypeList', {
            bindings: {
                page: '<',
                filters: '<'
            },
            templateUrl: 'app/document-type/list.html',
            controller: function ($scope, $state, DocumentTypeService) {
                this.DocumentTypeService = DocumentTypeService;
                this.reset = () => this.filters = {}
                $scope.$on('document-type.updated', () => $state.reload());
            }
        })
        .controller('DocumentTypeDialogController', function ($scope, $rootScope, $uibModalInstance, data, toastr, Document, DocumentType) {
            this.item = data;

            this.$onInit = () => {
                Document.objectTypes(result => this.objectTypes = result);
            }

            this.cancel = () => $uibModalInstance.dismiss('Canceled');

            this.save = () => {
                let promise;
                if (this.item.id !== null) {
                    promise = DocumentType.update(this.item).$promise;
                } else {
                    promise = DocumentType.save(this.item).$promise;
                }
                return promise.then(result => {
                    $rootScope.$broadcast('document-type.updated');
                    $uibModalInstance.close(result);
                    toastr.success("Zapisano");
                });
            };
        })
        .config(function ($stateProvider) {
            $stateProvider.state('documentTypeList', {
                parent: 'app',
                url: '/document-type?{page:int}&{size:int}&sort&search',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'content@': "documentTypeList"
                },
                resolve: {
                    filters: $stateParams => angular.copy($stateParams),
                    page: (DocumentType, $stateParams) => DocumentType.table(angular.copy($stateParams)).$promise
                }
            });
        });
